import * as React from 'react';
import { inject } from 'mobx-react';
import { isVrbo } from 'src/common/stores/context-store-utils';
import { SharedUiPropertySpacesWrapper } from '../shared-ui/details/property-spaces-wrapper';
import { SpaceDetailsWrapper } from '../template-components/space-details-wrapper';
export const PropertySpaceDetails = inject('context')(({
  context
}) => isVrbo(context) ? React.createElement(SharedUiPropertySpacesWrapper, null) : React.createElement(SpaceDetailsWrapper, null));